export const DropzoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
  >
    <g clip-path="url(#clip0_3360_11097)">
      <path
        d="M45 23.9999H45.0293"
        stroke="currentColor"
        stroke-width="5.36318"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.5 63H18C15.6131 63 13.3239 62.0518 11.636 60.364C9.94821 58.6761 9 56.3869 9 54V18C9 15.6131 9.94821 13.3239 11.636 11.636C13.3239 9.94821 15.6131 9 18 9H54C56.3869 9 58.6761 9.94821 60.364 11.636C62.0518 13.3239 63 15.6131 63 18V37.5"
        stroke="currentColor"
        stroke-width="2.68159"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 48.0002L24 33.0002C26.784 30.3212 30.216 30.3212 33 33.0002L45 45.0002"
        stroke="currentColor"
        stroke-width="2.68159"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42.001 41.9999L45.001 38.9999C47.011 37.0679 49.351 36.5279 51.547 37.3799"
        stroke="currentColor"
        stroke-width="2.68159"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.999 57.0001H65.999"
        stroke="currentColor"
        stroke-width="2.68159"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.999 48.0001V66.0001"
        stroke="currentColor"
        stroke-width="2.68159"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3360_11097">
        <rect width="72" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
